import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Marca } from '../components/Marca';
import { Aviso, Boton, Campo } from '../components/ui';
import { ApiError, api } from '../lib/api';

export function Clave() {
  const { token = '' } = useParams();
  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);

  async function save() {
    setError(null);
    if (password !== repeat) {
      setError('Las dos contraseñas no coinciden.');
      return;
    }
    setSaving(true);
    try {
      await api.post('/auth/set-password', { token, password });
      setDone(true);
      setPassword('');
      setRepeat('');
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'No se ha podido establecer la contraseña.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="acceso">
      <section className="acceso-relato">
        <Marca tam="g" sobreOscuro />
        <h1>
          Una visita.
          <br />
          <em>Toda la casa detrás.</em>
        </h1>
      </section>
      <section className="acceso-formulario">
        <div className="pila">
          <Marca tam="s" conTexto={false} />
          <h2>Establecer contraseña</h2>
          {done ? (
            <>
              <Aviso tono="hecho">Contraseña establecida. Ya puede iniciar sesión.</Aviso>
              <Link to="/entrar">Ir a Entrar</Link>
            </>
          ) : (
            <>
              {error && <Aviso tono="error">{error}</Aviso>}
              <Campo etiqueta="Nueva contraseña" ayuda="Al menos 10 caracteres.">
                <input type="password" autoComplete="new-password" value={password}
                  onChange={(e) => setPassword(e.target.value)} />
              </Campo>
              <Campo etiqueta="Repita la contraseña">
                <input type="password" autoComplete="new-password" value={repeat}
                  onChange={(e) => setRepeat(e.target.value)} />
              </Campo>
              <Boton variante="clave" cargando={saving} disabled={password.length < 10 || !repeat}
                onClick={save}>Establecer contraseña</Boton>
              <p className="sutil">Si el enlace ha caducado o ya se usó, pida uno nuevo desde Entrar.</p>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
